/* ==========================================================
MYNTRA COLLECTION JS — PREMIUM HYBRID EDITION
ALL original functionality preserved 1:1 below.
Added (appended): dual-handle price range slider controller that feeds the
existing min/max inputs and the existing apply flow. No original logic changed.
========================================================== */
document.addEventListener("DOMContentLoaded", () => {

  /* ----------------------------------------------------------
     ROBUST BODY SCROLL LOCK (iOS/Android safe)
     Plain overflow:hidden on body does NOT stop touch scroll
     chaining on iOS, which is why the collection scrolled behind
     the open sort/filter drawer. Locking body with position:fixed
     (and restoring scroll position on unlock) fully prevents this.
     ---------------------------------------------------------- */
  let __lockScrollY = 0;
  let __lockCount = 0;
  function lockBodyScroll() {
    if (__lockCount === 0) {
      __lockScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.style.position = "fixed";
      document.body.style.top = `-${__lockScrollY}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.width = "100%";
      document.body.style.overflow = "hidden";
    }
    __lockCount++;
  }
  function unlockBodyScroll() {
    __lockCount = Math.max(0, __lockCount - 1);
    if (__lockCount === 0) {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";
      document.body.style.overflow = "";
      window.scrollTo(0, __lockScrollY);
    }
  }

  /* MOBILE FILTER DRAWER */
  const filterDrawer = document.getElementById("myntra-mobile-filter");
  const openFilterBtns = document.querySelectorAll("[data-open-filter]");
  const closeFilterBtns = document.querySelectorAll("[data-close-filter]");

  openFilterBtns.forEach(btn => {
    btn.addEventListener("click", () => {
      filterDrawer?.classList.add("active");
      lockBodyScroll();
    });
  });

  closeFilterBtns.forEach(btn => {
    btn.addEventListener("click", () => {
      filterDrawer?.classList.remove("active");
      unlockBodyScroll();
    });
  });

  /* MOBILE SORT DRAWER */
  const sortDrawer = document.getElementById("myntra-mobile-sort");
  const openSortBtns = document.querySelectorAll("[data-open-sort]");
  const closeSortBtns = document.querySelectorAll("[data-close-sort]");

  openSortBtns.forEach(btn => {
    btn.addEventListener("click", () => {
      sortDrawer?.classList.add("active");
      lockBodyScroll();
    });
  });

  closeSortBtns.forEach(btn => {
    btn.addEventListener("click", () => {
      sortDrawer?.classList.remove("active");
      unlockBodyScroll();
    });
  });

  /* MOBILE FILTER TABS */
  const tabs = document.querySelectorAll(".myntra-mobile-filter-tab");
  const sections = document.querySelectorAll(".myntra-mobile-filter-panel");

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      const target = tab.getAttribute("data-tab");
      tabs.forEach(t => t.classList.remove("active"));
      sections.forEach(s => s.classList.remove("active"));
      tab.classList.add("active");
      document.querySelector(`.myntra-mobile-filter-panel[data-content="${target}"]`)?.classList.add("active");
    });
  });

  /* CLEAR & APPLY FILTER BUTTONS */
  const clearBtn = document.querySelector(".myntra-clear-btn");
  clearBtn?.addEventListener("click", () => {
    document.querySelectorAll('#myntra-mobile-filter input[type="checkbox"]').forEach(input => {
      input.checked = false;
    });
  });

  const applyBtn = document.querySelector(".myntra-apply-btn");
  applyBtn?.addEventListener("click", () => {
    /* ----------------------------------------------------------
       MULTI-FILTER APPLY (FIXED)
       The old code navigated to the FIRST checked box's data-url, so
       every other selected filter was lost. Now we collect EVERY checked
       checkbox across ALL groups, plus the price inputs, and build ONE
       URL containing all parameters together. Sort + any unrelated query
       params are preserved.
       ---------------------------------------------------------- */
    const root = document.getElementById("myntra-mobile-filter");
    if (!root) return;

    // Start from current query so we keep sort_by and anything unrelated,
    // but strip all params that belong to the filter set we're rebuilding
    // (so unchecking actually removes them).
    const params = new URLSearchParams(window.location.search);

    // 1) Gather the param names this drawer manages, then delete them all.
    const managedParams = new Set();
    root.querySelectorAll('input[type="checkbox"][data-filter-param]').forEach(cb => {
      const p = cb.getAttribute("data-filter-param");
      if (p) managedParams.add(p);
    });
    // price param names (from hidden spans)
    const minParamEl = root.querySelector("[data-mobile-min-param]");
    const maxParamEl = root.querySelector("[data-mobile-max-param]");
    const minParam = minParamEl ? minParamEl.getAttribute("data-mobile-min-param") : null;
    const maxParam = maxParamEl ? maxParamEl.getAttribute("data-mobile-max-param") : null;
    if (minParam) managedParams.add(minParam);
    if (maxParam) managedParams.add(maxParam);

    managedParams.forEach(p => params.delete(p));

    // 2) Re-add every CHECKED checkbox's param=value (multi-value safe:
    //    list filters use the same param name repeated for each value).
    let anySelected = false;
    root.querySelectorAll('input[type="checkbox"][data-filter-param]:checked').forEach(cb => {
      const p = cb.getAttribute("data-filter-param");
      const v = cb.getAttribute("data-filter-value");
      if (p && v !== null && v !== "") {
        params.append(p, v);
        anySelected = true;
      }
    });

    // 3) Add price range from the number inputs (driven by slider too).
    const minEl = root.querySelector("[data-mobile-min-price]");
    const maxEl = root.querySelector("[data-mobile-max-price]");
    if (minParam && minEl && minEl.value !== "") { params.set(minParam, minEl.value); anySelected = true; }
    if (maxParam && maxEl && maxEl.value !== "") { params.set(maxParam, maxEl.value); anySelected = true; }

    // 4) Fallback: if for some reason no data-filter-param attributes exist
    //    (older markup), fall back to the first checked box's data-url so we
    //    never break the original behaviour.
    if (!anySelected) {
      const firstChecked = root.querySelector('input[type="checkbox"]:checked');
      if (firstChecked && firstChecked.getAttribute("data-url")) {
        window.location.href = firstChecked.getAttribute("data-url");
        return;
      }
    }

    const qs = params.toString();
    window.location.href = window.location.pathname + (qs ? "?" + qs : "");
  });

  /* CLOSE ON ESCAPE */
  document.addEventListener("keydown", e => {
    if (e.key === "Escape") {
      const wasFilterOpen = filterDrawer?.classList.contains("active");
      const wasSortOpen = sortDrawer?.classList.contains("active");
      filterDrawer?.classList.remove("active");
      sortDrawer?.classList.remove("active");
      if (wasFilterOpen) unlockBodyScroll();
      if (wasSortOpen) unlockBodyScroll();
    }
  });

  /* ==========================================================
     DUAL-HANDLE PRICE RANGE SLIDER (UX layer)
     - Does NOT replace existing inputs/forms; it drives them.
     - Desktop: writes into the form's number inputs (native submit).
     - Mobile: writes into #mobileMinPrice / #mobileMaxPrice and lets the
       existing Apply button flow proceed (URL built from params if present).
     ========================================================== */
  /* ==========================================================
     DUAL-HANDLE PRICE RANGE SLIDER (UX layer + Auto Submit)
     ========================================================== */
  (function initPriceSliders() {
    const sliders = document.querySelectorAll("[data-price-slider]");
    if (!sliders.length) return;

    const formatINR = (n) => "₹" + Number(n).toLocaleString("en-IN");

    sliders.forEach(slider => {
      const min = parseInt(slider.dataset.min, 10) || 0;
      const max = parseInt(slider.dataset.max, 10) || 100000;
      const minInput = slider.querySelector('[data-slider-handle="min"]');
      const maxInput = slider.querySelector('[data-slider-handle="max"]');
      const range = slider.querySelector("[data-slider-range]");
      const displayMin = slider.parentElement.querySelector('[data-slider-display="min"]');
      const displayMax = slider.parentElement.querySelector('[data-slider-display="max"]');
      const isMobile = slider.hasAttribute("data-mobile-slider");

      // Linked number inputs
      let numMin, numMax;
      if (isMobile) {
        numMin = document.querySelector("[data-mobile-min-price]");
        numMax = document.querySelector("[data-mobile-max-price]");
      } else {
        const form = slider.closest("[data-price-form]");
        numMin = form ? form.querySelector('[data-price-input="min"]') : null;
        numMax = form ? form.querySelector('[data-price-input="max"]') : null;
      }

      if (!minInput || !maxInput || !range) return;

      const gap = Math.max(1, Math.round((max - min) * 0.01)); // 1% min gap

      function pct(v) { return ((v - min) / (max - min)) * 100; }

      function paint() {
        let lo = parseInt(minInput.value, 10);
        let hi = parseInt(maxInput.value, 10);
        if (lo > hi - gap) {
          if (document.activeElement === minInput) {
            lo = hi - gap;
            minInput.value = lo;
          } else {
            hi = lo + gap;
            maxInput.value = hi;
          }
        }
        range.style.left = pct(lo) + "%";
        range.style.width = (pct(hi) - pct(lo)) + "%";
        if (displayMin) displayMin.textContent = formatINR(lo);
        if (displayMax) displayMax.textContent = formatINR(hi);
        if (numMin) numMin.value = (lo > min) ? lo : "";
        if (numMax) numMax.value = (hi < max) ? hi : "";
      }

      function bumpZ(active) {
        minInput.style.zIndex = active === minInput ? 5 : 4;
        maxInput.style.zIndex = active === maxInput ? 5 : 4;
      }

      // Visual updates while dragging (Live preview)
      minInput.addEventListener("input", () => { bumpZ(minInput); paint(); });
      maxInput.addEventListener("input", () => { bumpZ(maxInput); paint(); });

      // If user edits the number inputs directly, reflect onto slider
      if (numMin) {
        numMin.addEventListener("input", () => {
          let v = parseInt(numMin.value, 10);
          if (!isNaN(v)) { minInput.value = Math.min(Math.max(v, min), max); paint(); }
        });
      }
      if (numMax) {
        numMax.addEventListener("input", () => {
          let v = parseInt(numMax.value, 10);
          if (!isNaN(v)) { maxInput.value = Math.min(Math.max(v, min), max); paint(); }
        });
      }

      // --- AUTO-SUBMIT LOGIC (DESKTOP ONLY) ---
      const form = slider.closest("[data-price-form]");
      if (form && !isMobile) {
        const applyPriceFilter = () => {
          const currentUrl = new URL(window.location.href);
          
          const minName = numMin ? numMin.getAttribute('name') : null;
          const maxName = numMax ? numMax.getAttribute('name') : null;

          // Min price handling
          if (numMin && numMin.value !== "" && minName) {
            currentUrl.searchParams.set(minName, numMin.value);
          } else if (minName) {
            currentUrl.searchParams.delete(minName);
          }

          // Max price handling
          if (numMax && numMax.value !== "" && maxName) {
            currentUrl.searchParams.set(maxName, numMax.value);
          } else if (maxName) {
            currentUrl.searchParams.delete(maxName);
          }
          
          // Force apply filter without clearing other checkboxes
          window.location.href = currentUrl.toString();
        };

        // Trigger submit ONLY when the user lets go of the slider (change event)
        minInput.addEventListener("change", applyPriceFilter);
        maxInput.addEventListener("change", applyPriceFilter);
        if (numMin) numMin.addEventListener("change", applyPriceFilter);
        if (numMax) numMax.addEventListener("change", applyPriceFilter);
      }

      paint();
    });
  })();

  /* ==========================================================
     (Mobile price apply is now handled inside the main multi-filter
     APPLY handler above, which merges price + all checkbox filters into
     a single URL. The old separate price-only handler was removed to
     avoid double navigation.)
     ========================================================== */

  /* ==========================================================
     SIDEBAR FILTER GROUP EXPAND / COLLAPSE (UX)
     Toggles a class on the group; CSS handles open/closed visuals.
     Default: all open (so no functional change if CSS ignores it).
     ========================================================== */
  (function filterAccordion() {
    document.querySelectorAll(".myntra-filter-group .myntra-filter-title").forEach(title => {
      title.addEventListener("click", () => {
        const group = title.closest(".myntra-filter-group");
        if (group) group.classList.toggle("collapsed");
      });
    });
  })();

  /* ==========================================================
     WISHLIST ICON CONTROLLER (Desktop + Mobile)
     - Card heart button lives INSIDE the product <a> link, so we must
       stop the click from navigating to the product page (this was the
       "desktop opens product / mobile does nothing" bug).
     - Toggles the product HANDLE in localStorage key
       'shopify_custom_wishlist' (same key the Wishlist page reads).
     - Adds .active for the blue/filled state.
     - Updates the header '.wishlist-count-badge' and fires
       'wishlist:updated' so the header + wishlist page stay in sync.
     ========================================================== */
  (function wishlistController() {
    const STORAGE_KEY = "shopify_custom_wishlist";

    const readList = () => {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
      catch (e) { return []; }
    };
    const writeList = (list) => {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      window.dispatchEvent(new CustomEvent("wishlist:updated", { detail: list }));
    };

    const updateHeaderCount = (list) => {
      document.querySelectorAll(".wishlist-count-badge").forEach(b => { b.textContent = list.length; });
    };

    const buttons = document.querySelectorAll(".myntra-wishlist-btn");
    if (!buttons.length) {
      updateHeaderCount(readList());
      return;
    }

    let list = readList();
    buttons.forEach(btn => {
      const handle = btn.getAttribute("data-product-handle");
      if (handle && list.includes(handle)) {
        btn.classList.add("active");
        btn.setAttribute("aria-pressed", "true");
      }
    });
    updateHeaderCount(list);

    buttons.forEach(btn => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const handle = btn.getAttribute("data-product-handle");
        if (!handle) return;

        let current = readList();
        const idx = current.indexOf(handle);
        if (idx === -1) {
          current.push(handle);
          btn.classList.add("active");
          btn.setAttribute("aria-pressed", "true");
        } else {
          current.splice(idx, 1);
          btn.classList.remove("active");
          btn.setAttribute("aria-pressed", "false");
        }
        writeList(current);
        updateHeaderCount(current);
      });
    });

    const refresh = (updated) => {
      buttons.forEach(btn => {
        const handle = btn.getAttribute("data-product-handle");
        const on = handle && updated.includes(handle);
        btn.classList.toggle("active", !!on);
        btn.setAttribute("aria-pressed", on ? "true" : "false");
      });
      updateHeaderCount(updated);
    };

    window.addEventListener("wishlist:updated", (e) => {
      refresh((e.detail && Array.isArray(e.detail)) ? e.detail : readList());
    });
    window.addEventListener("storage", (e) => {
      if (e.key === STORAGE_KEY) refresh(readList());
    });
  })();
/* ==========================================================
     1. DESKTOP & MOBILE SORTING FIX
     Preserves active filters while applying the new sort parameter.
     ========================================================== */
/* ==========================================================
     1. DESKTOP & MOBILE SORTING (100% BULLETPROOF FIX)
     Reads exact sort value from data-attribute. Failsafe method.
     ========================================================== */
  (function initSorting() {
    // Desktop Sort
    const sortSelect = document.getElementById('SortByDesktop');
    if (sortSelect) {
      sortSelect.addEventListener('change', (e) => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', e.target.value);
        window.location.href = url.toString();
      });
    }

    // Mobile Sort
    const mobileSortOptions = document.querySelectorAll('.myntra-mobile-sort-option');
    mobileSortOptions.forEach(option => {
      option.addEventListener('click', function(e) {
        e.preventDefault(); // Stop default navigation
        
        // 1. Instant UI Update: Change blue tick immediately
        mobileSortOptions.forEach(opt => opt.classList.remove('active'));
        this.classList.add('active');

        // 2. Get the exact sorting value directly from the HTML attribute
        const sortVal = this.getAttribute('data-sort-value');
        const currentUrl = new URL(window.location.href);

        // 3. Set the parameter safely
        if (sortVal) {
          currentUrl.searchParams.set('sort_by', sortVal);
        } else {
          currentUrl.searchParams.delete('sort_by');
        }
        
        // 4. Force Page Reload
        window.location.href = currentUrl.toString();
      });
    });
  })();
/* ==========================================================
     2. SUPER SMOOTH SMART STICKY SIDEBAR (NO SHAKING)
     Uses native CSS sticky and only adjusts the 'top' boundary
     dynamically. Prevents layout thrashing and jitter.
     ========================================================== */
  (function initSmoothSmartSticky() {
    const sidebar = document.querySelector('.myntra-sidebar--sticky');
    if (!sidebar) return;

    let lastScrollY = window.scrollY || document.documentElement.scrollTop;
    let currentTop = 20; // Top offset margin (20px)

    window.addEventListener('scroll', () => {
      if (window.innerWidth < 991) {
        sidebar.style.top = '0px'; // Mobile ku default
        return;
      }

      const scrollY = window.scrollY || document.documentElement.scrollTop;
      const scrollDelta = scrollY - lastScrollY;
      const viewportHeight = window.innerHeight;
      const sidebarHeight = sidebar.offsetHeight;

      // Sidebar screen-ai vida chinnatha iruntha (Normal Sticky)
      if (sidebarHeight <= viewportHeight) {
        sidebar.style.top = '20px';
      } 
      // Sidebar screen-ai vida perusa iruntha (Smart Directional Sticky)
      else {
        if (scrollDelta > 0) {
          // SCROLLING DOWN (Kela pogum pothu)
          currentTop -= scrollDelta;
          const minTop = viewportHeight - sidebarHeight - 20; // Bottom 20px buffer
          if (currentTop < minTop) {
            currentTop = minTop; // Bottom boundary hit aana apram stick aagum
          }
        } else {
          // SCROLLING UP (Mela pogum pothu)
          currentTop -= scrollDelta;
          if (currentTop > 20) { // Top 20px buffer
            currentTop = 20; // Top boundary hit aana apram stick aagum
          }
        }
        // Native sticky oda boundary ah mattum update pandrom (No transform jitter)
        sidebar.style.top = `${currentTop}px`;
      }

      lastScrollY = scrollY;
    }, { passive: true }); // Passive true makes scroll event non-blocking and smoother
  })();
  
});
